(() => {
  const SELECTOR = '[data-before-after]';

  function initializeComparison(section) {
    if (!section || section.dataset.baInitialized === 'true') {
      return;
    }

    const comparison = section.querySelector('[data-ba-comparison]');
    const range = section.querySelector('[data-ba-range]');

    if (!comparison || !range) {
      section.dataset.baInitialized = 'true';
      return;
    }

    const updatePosition = () => {
      const value = Math.min(100, Math.max(0, Number(range.value)));

      section.style.setProperty('--ba-position', `${value}%`);
      range.setAttribute('aria-valuetext', `${value} por ciento`);
    };

    range.addEventListener('input', updatePosition);
    range.addEventListener('change', updatePosition);

    updatePosition();
    section.dataset.baInitialized = 'true';
  }

  function initializeAll(container = document) {
    container.querySelectorAll(SELECTOR).forEach(initializeComparison);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initializeAll();
  });
})();